import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Route guard. Redirects to /login if not authenticated; to /change-password
 * if the user has must_change_password=true; otherwise renders children.
 *
 * Optional prop `roles` restricts access to specific roles.
 */
export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "var(--bg-app)" }}
      >
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  if (user.must_change_password && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return (
      <div
        className="min-h-screen flex items-center justify-center p-6"
        style={{ background: "var(--bg-app)" }}
      >
        <div
          className="max-w-md rounded-lg p-6 text-center"
          style={{
            background: "var(--bg-surface)",
            border: "1px solid var(--border-subtle)",
          }}
        >
          <div
            className="font-semibold text-[16px] mb-1"
            style={{ color: "var(--text-primary)" }}
          >
            Accesso negato
          </div>
          <div
            className="text-[13px]"
            style={{ color: "var(--text-secondary)" }}
          >
            Questa pagina richiede privilegi superiori al tuo ruolo
            ({user.role}).
          </div>
        </div>
      </div>
    );
  }
  return children;
}
